import { render } from "./SuiviCom.vue?vue&type=template&id=c2b81c1a"
import script from "./SuiviCom.vue?vue&type=script&lang=js"
export * from "./SuiviCom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__